
import React from "react";

export const Shape = () => {
  return <>Shape</>;
};